// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "premcalc-static/js/" + chunkId + "." + {"34":"9c974a48","70":"f2f2d0a1","567":"71761d74"}[chunkId] + ".chunk.js";
};